export default __webpack_public_path__ + "static/media/help--hero-lg.ec1f98a0.png";